<section class="container">
  <app-tp-about-silvio-santos-holding class="about-silvio-santos">
    <strong>Grupo Silvio Santos</strong> 65 anos ao lado dos brasileiros
  </app-tp-about-silvio-santos-holding>

  <div class="disclaimer">
    <app-tp-legal-terms-text
      id="footerLegalTerms"
      [currentProduct]="currentProduct"
      [isEndNote]="true" />
  </div>

  <p>&#169; 2024 Tele Prêmios da Sorte | Todos os direitos reservados</p>
</section>
